import React from 'react';

export const useToggle = (initialValue = false): [boolean, () => void] => {
  const [state, setState] = React.useState(initialValue);

  const toggle = React.useCallback(() => setState((currentState) => !currentState), []);

  return [state, toggle];
};

export default useToggle;
